import React, { useRef } from 'react';
import { useOnClickOutside } from 'usehooks-ts';

import Check from '@/assets/icons/Check';
import { ThemeOption } from '@/contextProviders/themeProvider';

import styles from './MoreInformation.module.css';

export const ThemeDialog = ({
  isOpen,
  onClose,
  onSelectTheme,
  selectedTheme,
}: {
  isOpen: boolean;
  onClose: () => void;
  onSelectTheme: (theme: ThemeOption) => void;
  selectedTheme: ThemeOption;
}) => {
  const menuRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(menuRef as React.RefObject<HTMLElement>, onClose);

  if (!isOpen) return null;

  return (
    <div className={styles.infoMenuStyle} ref={menuRef}>
      <div className={styles.infoLinkItemsStyle} data-testid='themeMenu'>
        <div
          data-testId='theme-light'
          className={styles.infoLinkItemStyle}
          style={{ justifyContent: 'space-between' }}
          onClick={() => {
            onSelectTheme('light');
            onClose();
          }}
        >
          <span>Licht</span>
          {selectedTheme === 'light' && <Check width={20} height={20} fill='var(--tractie-color-content-emphasis)' />}
        </div>
        <div
          data-testId='theme-dark'
          className={styles.infoLinkItemStyle}
          style={{ justifyContent: 'space-between' }}
          onClick={() => {
            onSelectTheme('dark');
            onClose();
          }}
        >
          <span>Donker</span>
          {selectedTheme === 'dark' && <Check width={20} height={20} fill='var(--tractie-color-content-emphasis)' />}
        </div>
        <div
          data-testId='dark-high-contrast'
          className={styles.infoLinkItemStyle}
          style={{ justifyContent: 'space-between' }}
          onClick={() => {
            onSelectTheme('high-contrast-dark');
            onClose();
          }}
        >
          <span>Donker (hoog contrast)</span>
          {selectedTheme === 'high-contrast-dark' && (
            <Check width={20} height={20} fill='var(--tractie-color-content-emphasis)' />
          )}
        </div>
      </div>
    </div>
  );
};
